<div class="modal-content">
    <div class="d-flex justify-content-center my-2">
        <div class="step-indicator d-flex">
            <div class="step active">
                <div class="step-number">1</div>
                <div class="step-text">Monto Final</div>
            </div>
            <div class="step-line"></div>
            <div class="step" [ngClass]="{ active: step === 'observations' }">
                <div class="step-number">2</div>
                <div class="step-text">Observaciones</div>
            </div>
        </div>
    </div>

    <div *ngIf="step === 'amount'">
        <div class="modal-header">
            <h2 class="modal-title">{{ getModalTitle() }}</h2>
            <p class="subtitle">{{ getModalSubtitle() }}</p>
        </div>

        <div class="row p-3">
            <div class="form-group d-flex flex-column">
                <div class="d-flex align-items-center gap-2">
                    <label for="finalAmount" class="box-text me-3"><strong>Monto final (USD):</strong></label>
                    <div class="input-group custom-width">
                        <input id="finalAmount" class="form-control box-input-span" type="number" min="0" step="0.01" required [(ngModel)]="finalAmountUSD" name="finalAmount" #finalAmount="ngModel" />
                        <div *ngIf="finalAmount.invalid && (finalAmount.dirty || finalAmount.touched)">
                            <small class="text-danger" *ngIf="finalAmount.errors?.['required']">Campo requerido</small>
                            <small class="text-danger" *ngIf="finalAmount.errors?.['min']">Valor mínimo: 0</small>
                        </div>
                        <span class="currency">$</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer d-flex justify-content-end gap-2">
            <button class="btn btn-outline-secondary" (click)="cancelClose()" type="button">Cancelar</button>
            <button
                class="btn btn-primary"
                (click)="proceedToObservations()"
                type="button"
                [disabled]="finalAmount?.invalid || loading || !(this.userService.user$ | async)?.permissions?.POS?.includes('close-cashbox')"
            >
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Cerrar caja
            </button>
        </div>
    </div>

    <div *ngIf="step === 'observations'">
        <div class="modal-header">
            <h2 class="modal-title">Resultado del cierre</h2>
        </div>

        <div class="row p-3">
            <div *ngIf="hasDiscrepancy" class="alert alert-warning">
                <div class="d-flex align-items-center mb-2">
                    <i class="fa fa-exclamation-triangle me-2"></i>
                    <strong>{{ discrepancy > 0 ? 'Sobrante detectado' : 'Faltante detectado' }}</strong>
                </div>
                <p>
                    {{ discrepancy > 0 ? 'Hay más dinero del esperado.' : 'Hay menos dinero del esperado.' }}
                    Diferencia: {{ (discrepancy > 0 ? discrepancy : -discrepancy) | currency: 'USD':'symbol':'1.2-2' }}
                </p>
            </div>

            <div *ngIf="!hasDiscrepancy" class="alert alert-success">
                <div class="d-flex align-items-center mb-2">
                    <i class="fa fa-check-circle me-2"></i>
                    <strong>Todo en orden</strong>
                </div>
                <p>No hay diferencias entre el monto inicial y final.</p>
            </div>

            <div class="card mb-3">
                <div class="card-body">
                    <div class="d-flex justify-content-between mb-2">
                        <span>Monto inicial:</span>
                        <span>{{ closedCashbox?.initialAmountUSD | currency: 'USD':'symbol':'1.2-2' }}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <span>Monto esperado:</span>
                        <span>{{ closedCashbox?.currentAmountUSD | currency: 'USD':'symbol':'1.2-2' }}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <span>Monto final:</span>
                        <span>{{ closedCashbox?.finalAmountUSD | currency: 'USD':'symbol':'1.2-2' }}</span>
                    </div>
                    <div class="d-flex justify-content-between fw-bold">
                        <span>Diferencia:</span>
                        <span>{{ closedCashbox?.discrepancy | currency: 'USD':'symbol':'1.2-2' }}</span>
                    </div>
                </div>
            </div>

            <div class="form-group mb-3">
                <label for="observaciones" class="form-label"><strong>Observaciones</strong></label>
                <textarea class="form-control" id="observaciones" name="observaciones" rows="3" placeholder="Agregue observaciones sobre el cierre de caja..." [(ngModel)]="observaciones"></textarea>
            </div>
        </div>

        <div class="modal-footer d-flex justify-content-end gap-2">
            <button class="btn btn-primary" (click)="closeCashbox()" type="button" [disabled]="loading || !(this.userService.user$ | async)?.permissions?.POS?.includes('close-cashbox')">
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Finalizar
            </button>
        </div>
    </div>

    <div
        id="animation-confetti"
        class="animation-container"
        [ngClass]="{ 'd-none': hasDiscrepancy || step === 'amount' }"
        style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 0; pointer-events: none"
    ></div>
</div>
